import { useState, useEffect } from "react";
import React from "react";
import small1 from "./images/ClowdsIcon.png";
import { IoIosAddCircleOutline } from "react-icons/io";
import { AiFillEdit } from "react-icons/ai";
import { FaCopy } from "react-icons/fa";

import Loading from "./Loading";

import "flowbite";
import { Link, useLocation } from "react-router-dom";
import Profile from "./Profile";
import { useAccount } from "wagmi";
import { ToastContainer, toast } from "react-toastify";

import { Toaster } from "react-hot-toast";
import axios from "axios";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import { SubscriptionAddress } from "./Contracts/Subscription";
import { SubscriptionAbi } from "./Contracts/Subscription";
import { ConnectButton } from "@rainbow-me/rainbowkit";

import { BoxAbi } from "./Contracts/Box";
// import Signinoption from "./Signinoption";
import { useNavigate } from "react-router-dom";
import SetBoxName from "./SetBoxName";
import { getMagic } from "./web3";
const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

//cutom Signer
const customProvider = new ethers.providers.JsonRpcProvider(NODE_URL);
const customSigner = new ethers.Wallet(privateKey, customProvider);

// end Custom Signer
const CreatorDashboard = () => {
  const [isVisiter, setIsVisiter] = useState(false);
  const navigate = useNavigate();
  const JWT = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI3MzVmZGI5My00NWVjLTRiOWQtODgxMi1mMDhhYWRkMjI3YWUiLCJlbWFpbCI6ImZhaGVlbWZlcm96MTExOUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJpZCI6IkZSQTEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX0seyJpZCI6Ik5ZQzEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiM2JkYzdhZjYxYTkxNDBjM2FhOTIiLCJzY29wZWRLZXlTZWNyZXQiOiI5NmU5MTM5ZTlhYTQ2ZDhmZDRjMWM4ZjdiM2EyZGEzNGQzY2EyODY0N2U3ODRkYTliY2E0MmNkOTE2NTA4MzM3IiwiaWF0IjoxNjc5OTkxNTg5fQ.iTA1cmseF9_LFXFVgVIUfV_Q7UzqVBkhQ60XpScuhyE`;

  //will remove it
  //   let isMagic=localStorage.getItem("isMagic");
  //   let magicAddress=localStorage.getItem("magicAddress");
  // console.log("isMagic",isMagic)
  // console.log("MagicAddress",magicAddress)
  //
  let userData = JSON.parse(localStorage.getItem("userData"));
  console.log("User", userData);
  let walletType = userData?.walletType;
  let walletAddress = userData?.walletAddress;
  let userRole = userData?.role;
  const [balance, setBalance] = useState(0);
  customProvider.getBalance(userData?.walletAddress).then((res) => {
    console.log("Balance", ethers.utils.formatEther(res));
    localStorage.setItem(
      "walletBalance",
      parseFloat(ethers.utils.formatEther(res)).toFixed(4)
    );
    setBalance(parseFloat(ethers.utils.formatEther(res)).toFixed(4));
  });
  // localStorage.setItem("walletBalance", ethers.utils.formatEther(getBalance()))
  // console.log("Balance", getBalance());

  // if(userRole=="vister"){
  //   setIsVisiter(true)
  // }
  if (walletType == "magicLink") {
    localStorage.setItem("isMagic", true);
    getMagic();
  } else {
    localStorage.setItem("isMagic", false);
  }
  // if()
  console.log("Wallet Type", walletType);
  console.log("Wallet Address", walletAddress);

  const { BigNumber } = require("ethers");
  const [plan, setPlans] = useState([]);
  const [newAddress, setNewAddress] = useState("");
  const [boxes, setBoxes] = useState([]);
  const [visiterBoxes, setVisiterBoxes] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(false);

  const [dialog, setDialog] = useState(false);
  const [dialog1, setDialog1] = useState(false);
  const [allowedUsers, setAllowedUsers] = useState([]);
  const { address } = useAccount();
  const [email, setEmail] = useState();
  const [subAddress, setSUbAddress] = useState();
  const [namepopup, setNamepopup] = useState(false);
  const namepopupHandel = () => {
    namepopup ? setNamepopup(false) : setNamepopup(true);
  };

  console.log("SUBADDRES", subAddress);
  console.log("new adress", newAddress);
  localStorage.setItem("newaddress", newAddress);
  const { data: signer } = useSigner();
  let contract;
  let boxcontract;

  if (customSigner) {
    boxcontract = new ethers.Contract(newAddress, BoxAbi, customSigner);
  }

  if (customSigner) {
    contract = new ethers.Contract(
      SubscriptionAddress,
      SubscriptionAbi,
      customSigner
    );
  }
  const planss = localStorage.getItem("plan");
  const packages = localStorage.getItem("package");
  const token = localStorage.getItem("token");
  console.log("plan", plan);
  console.log("package", packages);
  const [show, setShow] = useState(true);
  const [index, setIndex] = useState();
  console.log("index", index);

  const [storage, setStorage] = useState("");
  const [boxName, setBoxName] = useState();

  const getAllBoxes = async () => {
    setIsLoading(true);

    // try {
    if (token == undefined) {
      setIsLoading(false);
      // console.error("Error logging in:", error);
      localStorage.setItem("reload", true);
      navigate("/#");
    } else {
      // await axios
      //   .get(`${process.env.REACT_APP_SERVER_URL}/payment-history`, {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   })
      //   .then(async (res) => {
      if (boxStatus == 2) {
        userRole = "vister";
      } else {
        userRole = "owner";
      }
      console.log("user role", userRole, status);
      if (userRole == "vister") {
        setIsVisiter(true);
        const res = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/visiter-subscriptions`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.success) {
          setBoxStatus(2);
          console.log("Response", res?.data?.subscriptions[0]?.address);
          let c = [];
          res?.data?.subscriptions.map((item) => {
            c.i = index;
            c.push(item?.address);
          });
          console.log("Visitersssss", c);
          setVisiterBoxes(c);
          // setVisiterBoxes([res?.data]);
          // for (let i = 0; i <= info.length - 1; i++) {
          //   console.log(" res Info", res[i]);
          //   let bContract = new ethers.Contract(
          //     res[i].boxAddress,
          //     BoxAbi,
          //     customSigner
          //   );

          //   bContract.getUsedStorage().then((ress) => {
          //     setBoxes((oldinfo) => [
          //       ...oldinfo,
          //       {
          //         res: res[i],
          //         usedStorage: ethers.BigNumber.from(ress).toString(),
          //       },
          //     ]);
          //   });

          //   const price = BigNumber.from(res[i]?.plan?.storageAvailable);
          //   const prices = price.toString();
          //   console.log("prices", prices);
          //   const round = prices / 1024;
          //   const sizeMb = parseInt(round);
          //   setStorage(sizeMb);
          // }
          setIsLoading(false);
        }
      } else {
        setIsVisiter(false);

        await contract
          ?.getUserAllBoxesInfo(walletAddress)
          .then(async (info) => {
            let res = info;
            console.log("getUserAllBoxesInfo", res);
            setBoxes([]);
            for (let i = 0; i <= info.length - 1; i++) {
              console.log(" res Info", res[i]);

              let bName = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/subscription/${res[i].boxAddress}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              console.log(
                "bbbbbbbbbnameeeeeeeeeeeeeeeeeeeeeeeeeee",
                bName?.data?.subscription?.name
              );
              let bContract = new ethers.Contract(
                res[i].boxAddress,
                BoxAbi,
                customSigner
              );

              bContract.getUsedStorage().then((ress) => {
                setBoxes((oldinfo) => [
                  ...oldinfo,
                  {
                    res: res[i],
                    usedStorage: ethers.BigNumber.from(ress).toString(),
                    name: bName?.data?.subscription?.name,
                  },
                ]);
              });

              const price = BigNumber.from(res[i]?.plan?.storageAvailable);
              const prices = price.toString();
              console.log("prices", prices);
              const round = prices / 1024;
              const sizeMb = parseInt(round);
              setStorage(sizeMb);
            }
          });
        setIsLoading(false);
      }
      // });
      // } catch (error) {
      //   setIsLoading(false);
      //   console.error("Error logging in:", error);
      //   // localStorage.setItem("reload", true);
      //   // navigate("/#");
      // }
    }
  };
  const [boxStatus, setBoxStatus] = useState(1);
  // console.log("Boxessssss",boxes)
  useEffect(() => {
    if (customSigner) {
      // setBoxes([]);

      getAllBoxes();
    }
  }, [customSigner, status, boxStatus]);

  const inviteUser = async () => {
    console.log("subAddress", subAddress);
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/invite`,
      { email: email, subAddress: subAddress, index: index },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (res.data.success) {
      console.log("Successfuly ", res.data);

      toast("Email Successfuly Sent", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      // alert("Open this link in the User browser :" + res.data.data.link);
    } else {
      console.log("error ", res.data.msg);
      toast(res.data.msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      // alert(res.data.msg);
    }
  };
  console.log("Alowed Users", allowedUsers);

  const updateNameInput = async (e) => {
    const res = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/subscription`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("getnamedata ksjfhskfhskfh", res);
    if (res.data.success) {
      console.log("Successfuly ", res.data);

      toast("Succesfully Updated", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setStatus(!status);

      // alert("Open this link in the User browser :" + res.data.data.link);
    } else {
      toast.error("Error while updating name. Please try");
    }
  };
  return (
    <div style={{ opacity: 1 }} className="relative z-50">
      <div className="antialiased bg-[#212445]  w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl my-10 px-2">
          <Profile />

          <div
            id="content"
            className="bg-[rgb(21,28,44)] col-span-9 rounded-lg p-6 relative z-30"
          >
            <div>
              <h1 className="font-bold py-4 uppercase">Boxes</h1>

              {/* {walletType == "magicLink" ? null : ( */}
              <>
                <div className="flex gap-5 mb-5">
                  <button
                    onClick={() => setBoxStatus(1)}
                    className={` ${
                      boxStatus == 1 ? " bg-white " : " bg-slate-400 "
                    }  rounded-sm px-8 py-2 text-black font-[600]`}
                  >
                    Owner
                  </button>

                  <button
                    onClick={() => setBoxStatus(2)}
                    className={` ${
                      boxStatus == 2 ? " bg-white " : " bg-slate-400 "
                    }  rounded-sm px-8 py-2 text-black font-[600]`}
                  >
                    Visiter
                  </button>
                </div>
              </>
              {/* )} */}

              {boxStatus == 2 ? (
                visiterBoxes.length > 0 ? (
                  visiterBoxes.map((item, index) => (
                    <a
                      href="#/files"
                      key={index}
                      onClick={() => {
                        setShow(false);
                        setNewAddress(item);
                        localStorage.setItem("visiterBox", true);
                      }}
                      className="cursor-pointer block text-black bg-slate-300 p-2 rounded-sm my-2 w-[100%]"
                    >
                      {" "}
                      <span className="mr-20">{index}</span>{" "}
                      <span className="hidden md:inline-block"> {item}</span>
                      <span className="mr-20 md:hidden">
                        {" "}
                        {item?.slice(0, 4) + "..." + item?.slice(-4)}
                      </span>
                    </a>
                  ))
                ) : (
                  <div>You Don't have access to Box</div>
                )
              ) : (
                <div
                  id="stats"
                  className="grid grid-cols-1 sm:mx-auto md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
                >
                  {boxes.length > 0 ? (
                    boxes?.map((item, index) => (
                      <div
                        className="bg-[#23314c] rounded-lg hover:cursor-pointer w-fit mx-auto"
                        key={index}
                      >
                        <div
                          onClick={() => {
                            setShow(false);
                            setNewAddress(item?.res?.boxAddress);
                            localStorage.setItem("visiterBox", false);
                            console.log(
                              "sakjfdhskajdfhsakdjdfgaskjgfsakjdfgsakjdf",
                              item
                            );
                          }}
                          className={` flex justify-between text-sm font-bold pt-4 px-4`}
                        >
                          <p>{item?.name ? item?.name : "Box Name"}</p>
                          <p
                            onClick={() => {
                              namepopupHandel();
                            }}
                            className="text-lg font-bold ml-4 my-auto "
                          >
                            <AiFillEdit />
                          </p>
                        </div>

                        <div className="flex flex-row items-center">
                          <div className="p-4">
                            <a href="#/files">
                              <div
                                className="flex w-full justify-between gap-2 hover:cursor-pointer"
                                onClick={() => {
                                  setShow(false);
                                  setNewAddress(item?.res?.boxAddress);
                                  localStorage.setItem("visiterBox", false);
                                }}
                              >
                                <p className="text-sm font-bold">
                                  {item?.res?.boxAddress.slice(0, 4) +
                                    "..." +
                                    item?.res?.boxAddress.slice(-4)}
                                </p>
                                <p className="text-sm font-bold my-auto ">
                                  {item?.usedStorage < 1024
                                    ? item?.usedStorage +
                                      "kb/" +
                                      ethers.BigNumber.from(
                                        item?.res?.plan?.storageAvailable
                                      ).toString() /
                                        1024 +
                                      "Mb"
                                    : (item?.usedStorage / 1024).toFixed(2) +
                                      "Mb/" +
                                      ethers.BigNumber.from(
                                        item?.res?.plan?.storageAvailable
                                      ).toString() /
                                        1024 +
                                      "Mb"}
                                </p>
                              </div>
                            </a>
                            <div
                              onClick={async () => {
                                console.log("Token", token);
                                console.log("boxes", item?.res?.boxAddress);
                                let boxAddr = item?.res?.boxAddress;
                                let tokenn = token;
                                console.log(token, "dsad", boxAddr);
                                await axios(
                                  `${process.env.REACT_APP_SERVER_URL}/subscription-users/${boxAddr}`,

                                  {
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization:
                                        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Imtpbmdsb25lMTdAZ21haWwuY29tIiwiaWQiOiI2NDM5MzBmZmMwZTIxNDIyN2MyZWUwMWYiLCJyb2xlIjoib3duZXIiLCJpYXQiOjE2ODE3MTU0MjN9.hSWQ4mn4Ary-ziB8NxhAPW4XZr8cMszavHQtgDG-wRw",
                                    },
                                  }
                                ).then((res) => {
                                  setAllowedUsers(res?.data?.users);
                                  setDialog1(true);
                                });
                              }}
                              className=" flex  pt-3"
                            >
                              <img
                                src={small1}
                                className="relative rounded-full border-2 bg-black h-[30px] w-[30px] "
                              />
                            </div>

                            <div
                              className="justify-around gap-20 border-t border-white/5 mt-2 pt-3 flex"
                              onClick={async () => {
                                console.log("Token", token);
                                console.log("boxes", item?.res?.boxAddress);
                                let boxAddr = item?.res?.boxAddress;
                                let tokenn = token;
                                console.log(token, "dsad", boxAddr);
                                await axios(
                                  `${process.env.REACT_APP_SERVER_URL}/subscription-users/${boxAddr}`,

                                  {
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization:
                                        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Imtpbmdsb25lMTdAZ21haWwuY29tIiwiaWQiOiI2NDM5MzBmZmMwZTIxNDIyN2MyZWUwMWYiLCJyb2xlIjoib3duZXIiLCJpYXQiOjE2ODE3MTU0MjN9.hSWQ4mn4Ary-ziB8NxhAPW4XZr8cMszavHQtgDG-wRw",
                                    },
                                  }
                                ).then((res) => {
                                  if (res?.data?.users.length > 0) {
                                    toast.error("Already have one user");
                                  } else {
                                    setDialog(true);
                                    setSUbAddress(item?.res?.boxAddress);
                                    setIndex(index);
                                  }
                                });
                              }}
                            >
                              <span>Add User</span>
                              <span>
                                <IoIosAddCircleOutline
                                  size={20}
                                  color="white"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>You Don't have any Boxes</div>
                  )}
                </div>
              )}
              {boxStatus == 1 ? (
                <div className="m-4 p-2 text-red-500">
                  <span className="font-bold">Please Note:</span> one recipient
                  per box is allowed. Once a user’s email is added to a box, it
                  cannot be changed.
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      {dialog ? (
        <div
          className="relative z-40"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-black backdrop-blur bg-opacity-20"></div>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
              {/* <!-- Add User  --> */}
              <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#2a2f6c] rounded-lg shadow  w-[50%] mx-10">
                <button
                  onClick={() => {
                    setEmail("");
                    setDialog(false);
                  }}
                  type="button"
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                  data-modal-hide="adduser-modal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
                <div className="px-6 py-6 lg:px-8">
                  <h3 className="mb-4 text-xl text-left font-medium text-white dark:text-white">
                    Add User
                  </h3>

                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-left text-sm font-medium text-white dark:text-white"
                    >
                      Enter Email
                    </label>
                    <input
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      placeholder="Email"
                      required
                    />
                  </div>

                  <button
                    disabled={!email}
                    onClick={() => {
                      inviteUser().then(() => {
                        setDialog(false);
                      });
                    }}
                    className="w-full mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {dialog1 ? (
        <div
          className="relative z-40"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-black backdrop-blur bg-opacity-20"></div>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
              {/* <!-- Add User  --> */}
              <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#2a2f6c] rounded-lg shadow  w-[50%] mx-10">
                <button
                  onClick={() => {
                    setEmail("");
                    setDialog1(false);
                  }}
                  type="button"
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                  data-modal-hide="adduser-modal"
                >
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
                <div className="px-6 py-6 lg:px-8">
                  <h3 className="mb-4 text-xl text-left font-medium text-white dark:text-white">
                    Allowed Users
                  </h3>

                  {allowedUsers.length > 0 ? (
                    allowedUsers.map((user, index) => (
                      <>
                        <div key={index} className="text-left text-white ">
                          {user.email}
                        </div>
                        <hr className="mb-5" />
                      </>
                    ))
                  ) : (
                    <div className=" text-white ">No User is Allowed yet</div>
                  )}
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div
        onClick={() => {
          // console.log(localStorage.getItem("token"))
          // localStorage.clear()
          // window.location.reload();
          localStorage.setItem("reload", true);
          navigate("/#");
        }}
        className="absolute bottom-4 left-4 text-white bg-black px-3 py-1 rounded-sm cursor-pointer"
      >
        Logout
      </div>

      {localStorage.getItem("isMagic") == "false" ? (
        <div className="  px-5 text-white absolute top-2 right-8">
          <ConnectButton />
        </div>
      ) : (
        <div
          onClick={async () => {
            navigator.clipboard.writeText(walletAddress.toString());
          }}
          className=" bg-white rounded-sm flex gap-4 items-center px-5 text-black text-lg cursor-pointer absolute top-2 right-8"
        >
          <FaCopy />
          {balance > 0.001 ? balance + "ETH" : "Insufficient Balance"}
        </div>
      )}

      <Loading isLoading={isLoading} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {namepopup ? (
        <SetBoxName
          address={newAddress}
          closeNamePopup={namepopupHandel}
          updateNameInput={updateNameInput}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default CreatorDashboard;
